document.addEventListener('DOMContentLoaded', function () {
  var root = document.documentElement;

  // Auf Mobilgeräten und bei reduzierter Bewegung keine Animation: alles sofort sichtbar.
  if (window.matchMedia('(max-width: 749px)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches || typeof ScrollReveal === 'undefined') {
    root.classList.remove('sr');
    document.querySelectorAll('.sr-animate, .sr-animate--no-interval, .product-card-wrapper, .collection-card, .article-card-wrapper').forEach(function (el) {
      el.style.visibility = 'visible';
      el.style.opacity = '1';
    });
    return;
  }

  window.sr = ScrollReveal({
    duration: 800,
    origin: 'bottom',
    distance: '25px',
    scale: 0.85,
  });

  sr.reveal('.product-card-wrapper', { interval: 100 });
  sr.reveal('.collection-card', { interval: 100 });
  sr.reveal('.article-card-wrapper', { interval: 100 });
  sr.reveal('.sr-animate--no-interval:not(.product__media-wrapper):not(.product__info-wrapper)');

  // Produktbild und Produktinfos nie verstecken (sichtbar ohne Scrollen).
  document.querySelectorAll('.product__media-wrapper, .product__info-wrapper').forEach(function (el) {
    el.style.visibility = 'visible';
    el.style.opacity = '1';
  });
});
